import { Link } from "react-router-dom";
import type { ReactNode } from "react";
import type { ButtonTone } from "./Button";

export interface LinkButtonProps {
  to: string;
  tone?: ButtonTone;
  breathe?: boolean;
  auto?: boolean;
  className?: string;
  onClick?: () => void;
  children: ReactNode;
}

const toneClass: Record<ButtonTone, string> = {
  primary: "btn-primary",
  secondary: "btn-secondary",
  pill: "btn-pill",
  quiet: "btn-quiet",
  destructive: "btn-destructive",
};

/** A link that looks like a button. Navigation is a link, an action is a button. */
export function LinkButton({ to, tone = "primary", breathe = false, auto = false, className, onClick, children }: LinkButtonProps) {
  const classes = ["btn", toneClass[tone], auto ? "btn-auto" : "", breathe ? "anim-breathe" : "", "press-bounce", "as-link", className]
    .filter(Boolean)
    .join(" ");
  return (
    <Link className={classes} to={to} onClick={onClick}>
      {children}
    </Link>
  );
}
